namespace $ {
	const { per } = $mol_style_unit

	$mol_style_define($horrorgamelanding_subscribe, {
		background: { color: '#333783' },
		minWidth: '120px',
		minHeight: '120px',
	})
}
